/* eslint-disable */
export function formatPrice(amount, currency) {
  return amount >= 0.01
    ? new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currency,
      }).format(amount)
    : 'FREE';
}

export function minMaxPrice(min, max, currency) {
  return min === max
    ? formatPrice(max, currency)
    : `${formatPrice(min, currency)} - ${formatPrice(max, currency)}`;
}

export const pickProductColor = function(type) {
  switch (type) {
    // RARITY 8/8
    case 'Stream Package':
    case 'Stream Packages':
    case 'Diamond Stream Package':
      return {
        text: `var(--color-rarity8-text)`,
        background: `var(--color-rarity8-background)`,
      };
      break;
    // RARITY 7/8
    case 'Video Intros':
    case 'Stream Transition':
    case 'Transition':
    case 'Animated':
      return {
        text: `var(--color-rarity7-text)`,
        background: `var(--color-rarity7-background)`,
      };
      break;
    // RARITY 6/8
    case 'Stream Overlay':
    case 'Stream Alerts':
    case 'Alerts':
    case 'Camera slot':
      return {
        text: `var(--color-rarity6-text)`,
        background: `var(--color-rarity6-background)`,
      };
      break;
    // RARITY 5/8
    case 'Premade Emote':
    case 'Subscriber Badges':
      return {
        text: `var(--color-rarity5-text)`,
        background: `var(--color-rarity5-background)`,
      };
      break;
    // RARITY 4/8
    case 'Premade Logo':
    case 'Logos':
      return {
        text: `var(--color-rarity4-text)`,
        background: `var(--color-rarity4-background)`,
      };
      break;
    // RARITY 3/8
    case 'Social Media':
    case 'Stream Deck Icons':
      return {
        text: `var(--color-rarity3-text)`,
        background: `var(--color-rarity3-background)`,
      };
      break;
    // RARITY 2/8
    case 'Stream Panels':
    case 'Panels':
    case 'Stream Screens':
    case 'Screens & Banners':
      return {
        text: `var(--color-rarity2-text)`,
        background: `var(--color-rarity2-background)`,
      };
      break;
    // RARITY 1/8
    case 'Free Graphics':
    case 'Free':
      return {
        text: `var(--color-rarity1-text)`,
        background: `var(--color-rarity1-background)`,
      };
      break;
    default:
      return {
        text: `var(--color-primary-light)`,
        background: `var(--color-primary-subtle)`,
      };
  }
};
